import { TranslatorProvider } from "src/providers/translator.provider";
import { EnquiryModel, EnquiryStatus, EnquiryType } from "./enquiry.model";
import { EnquiryApplicationModel } from "./enquiry-application.model";
import { ChatModel, ChatType } from "../chat/chat.model";
import { ChatItemModel, ChatItemStyle, ChatItemType } from "../chat/chat-item.model";
import { EnquiryStatusDictionary } from "src/providers/enquiry.provider";
import * as moment from "moment";

export class EnquiryUserApplicationModel {

	constructor(
		public id: string,
		public isRead: boolean,
		public application: EnquiryApplicationModel,
		public enquiries: Array<EnquiryModel>
	) { }

	static toChatModel(userApplication: EnquiryUserApplicationModel, translator: TranslatorProvider): ChatModel {
		const chatModel = {
			id: userApplication.id,
			isRead: true,
			title: userApplication.application.title,
			type: ChatType.Enquiries
		} as ChatModel;

		const initApplicationNotification = this.convertToInitApplicationNotification(userApplication.application, translator);
		chatModel.items = [initApplicationNotification];

		if (!userApplication.enquiries) return chatModel;

		const convertedEnquiries = userApplication.enquiries.map(enquiry => {

			const item: ChatItemModel = {
				createdAt: moment.utc(enquiry.createdAt).local().toDate(),
				username: enquiry.username,
				fromClient: enquiry.fromClient,
				style: this.getStyle(enquiry.status),
			};

			const message = this.convertApplicationToMessage(userApplication.application.title, enquiry, translator);

			if (enquiry.fromClient) {
				// message
				item.title = this.getEnquiryType(enquiry, translator);
				if (enquiry.status === EnquiryStatus.PartialApproval) {
					item.message = message;
				}
				item.itemType = ChatItemType.Message;
			}
			else {
				// notice
				item.icon = EnquiryStatusDictionary[enquiry.status];
				item.title = this.getMessageTitle(userApplication.application.title, enquiry, translator);
				item.message = enquiry.message;
				item.itemType = enquiry.type === EnquiryType.Notice ? ChatItemType.Notice : ChatItemType.Message
			}

			return item;
		});

		chatModel.items.push(...convertedEnquiries);

		return chatModel;
	}

	private static convertToInitApplicationNotification(application: EnquiryApplicationModel, translator: TranslatorProvider): ChatItemModel {
		return {
			id: application.id,
			username: application.username,
			message: application.description,
			createdAt: application.createdAt,
			extra: `${translator.dictionary.Expiration}: ${moment(application.dateTo).format("DD.MM.YYYY")}`,
			itemType: ChatItemType.Information,
			fromClient: false,
			icon: EnquiryStatusDictionary[EnquiryStatus.None],

			style: ChatItemStyle.Danger,
		};
	}

	private static convertApplicationToMessage(applicationTitle: string, enquiry: EnquiryModel, translator: TranslatorProvider): string {
		if (enquiry.fromClient) {
			switch (enquiry.status) {
				case EnquiryStatus.Confirmed:
					return `${applicationTitle} ${translator.dictionary.was_approved}`;
				case EnquiryStatus.Rejected:
					return `${applicationTitle} ${translator.dictionary.was_rejected}`;
				case EnquiryStatus.PartialApproval: default:
					return enquiry.message;
			}
		}
		else {
			switch (enquiry.status) {
				case EnquiryStatus.Confirmed:
					return `${applicationTitle} ${translator.dictionary.was_approved}`;
				case EnquiryStatus.Rejected:
					return `${applicationTitle} ${translator.dictionary.was_rejected}`;
				case EnquiryStatus.PartialApproval: default:
					return enquiry.message;
			}
		}
	}

	private static getStyle(status: EnquiryStatus): ChatItemStyle {
		switch (status) {
			case EnquiryStatus.Rejected:
				return ChatItemStyle.Danger;
			case EnquiryStatus.PartialApproval:
				return ChatItemStyle.Warning;
			case EnquiryStatus.Confirmed:
				return ChatItemStyle.Success;
		}

		return ChatItemStyle.Success;
	}

	private static getEnquiryType(enquiry: EnquiryModel, translator: TranslatorProvider) {
		if (enquiry.status === EnquiryStatus.Confirmed) {
			return translator.dictionary.Confirm;
		}
		else if (enquiry.status === EnquiryStatus.Rejected) {
			return translator.dictionary.Reject;
		}
		else if (enquiry.status === EnquiryStatus.PartialApproval) {
			return translator.dictionary.Partial_approve
		}

		return '';
	}

	private static getMessageTitle(applicationTitle: string, enquiry: EnquiryModel, translator: TranslatorProvider) {
		if (enquiry.status === EnquiryStatus.Confirmed) {
			return applicationTitle + ' ' + translator.dictionary.was_approved;
		}
		else if (enquiry.status === EnquiryStatus.Rejected) {
			return applicationTitle + ' ' + translator.dictionary.was_rejected;
		}
		else if (enquiry.status === EnquiryStatus.PartialApproval) {
			return translator.dictionary.Partial_approve;
		}

		return '';
	}
}